webpackJsonp([270174675798707],{

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	__webpack_require__(45);
	
	__webpack_require__(10);
	
	var _reactAnimateOnScroll = __webpack_require__(11);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(14);
	
	__webpack_require__(13);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	__webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/ambassadors/Ishita_Suri_amb.jpg";
	var icon2 = "https://winpeforum.com/assets/ambassadors/Pooja_Parmar_amb.jpg";
	var icon3 = "https://winpeforum.com/assets/ambassadors/Pooja_Sharoff_amb.jpg";
	var icon4 = "https://winpeforum.com/assets/ambassadors/Shikha_Pareek_amb.jpg";
	var icon5 = "https://winpeforum.com/assets/elements/Shriya.jpeg";
	var icon6 = "https://winpeforum.com/assets/elements/vidhi.jpg";
	var icon7 = "https://winpeforum.com/assets/elements/AravindKrishnan.png";
	var icon8 = "https://winpeforum.com/assets/elements/SandeepNaik.png";
	var icon9 = "https://winpeforum.com/assets/elements/SatishChander.png";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var WiI = function (_Component) {
	  _inherits(WiI, _Component);
	
	  function WiI(args) {
	    _classCallCheck(this, WiI);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    return _this;
	  }
	
	  WiI.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  WiI.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  WiI.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe | Privacy Policy",
	        description: " \r ",
	        image: "https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "winpecollegium_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "winpecollegium_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "winpecollegium_content" },
	              _react2.default.createElement(
	                "div",
	                { className: "winpecollegium_mid_section" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "mid_winpecollegium_heading" },
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  " ",
	                  _react2.default.createElement(
	                    "div",
	                    { className: "m_heading" },
	                    "Winpe Privacy Policy"
	                  ),
	                  _react2.default.createElement("div", { className: "r_btm" })
	                ),
	                _react2.default.createElement(
	                  _reactAnimateOnScroll2.default,
	                  {
	                    delay: 0,
	                    duration: 3,
	                    animateIn: "slideInRight",
	                    offset: 300
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "winpecollegium_top_text", style: { textAlign: "justify" } },
	                    _react2.default.createElement(
	                      "i",
	                      null,
	                      "Last updated: 20/05/2026"
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "Winpe Development Private Limited and Winpe Development Forum (\u201CWinpe\u201D, \u201Cwe\u201D, \u201Cour\u201D, or \u201Cus\u201D) are committed to protecting your privacy and handling your personal data responsibly and transparently. ",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "This Privacy Policy explains how we collect, use, process, store, share, transfer, and protect personal data.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "This Privacy Policy is intended to comply with the provisions of the Digital Personal Data Protection Act, 2023 (\"DPDP Act\"), the Digital Personal Data Protection Rules, 2025, and any amendments thereto. ",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "By accessing our website, registering for our programmes, participating in our initiatives, subscribing to our communications, or otherwise engaging with Winpe, you acknowledge that you have read and understood this Privacy Policy.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "1. Scope of This Policy"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "This Privacy Policy applies to personal data collected through:"
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "The Winpe website"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Event and webinar registration forms"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Newsletter subscriptions"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Surveys, research initiatives, and program participation"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Email communications and other digital interactions with Winpe"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "This Policy does not apply to third-party websites, platforms, or services that may be linked through our website."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "2. Personal Data We Collect"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "We may collect and process the following categories of personal data:"
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Full name"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Email address"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Phone number"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Organisation name"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Job title/designation"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Event or webinar registration details"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Information submitted through forms, surveys, or applications"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Queries, feedback, or communication shared with us"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Any other information voluntarily provided by you"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "When you visit our website, certain technical information may be collected automatically, including IP address, browser type, device information, pages visited, and interaction data."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "If you participate in Winpe events or webinars hosted through third-party platforms, those platforms may independently collect certain information subject to their own privacy policies."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Individuals are responsible for ensuring that the personal data they provide to Winpe is accurate and kept reasonably up to date."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "3. Purpose of Processing Personal Data"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "We process personal data only for legitimate and communicated purposes, including:"
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Managing event registrations, webinars, programs, consultations and initiatives"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Sending updates, reminders, newsletters, and knowledge resources"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Responding to inquiries and feedback"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Conducting analytics and improving website functionality and user experience"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Maintaining participant records and generating internal reports"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Ensuring security and preventing misuse of our digital platforms"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Participation in Winpe events, webinars, interviews, recordings, photographs, videos, and knowledge-sharing initiatives may result in the creation and publication of content on Winpe's websites, reports, newsletters, social media channels, and other communication platforms."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "4. Legal Basis and Consent"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "By voluntarily providing your personal data through our website, forms, registrations, or communications, you consent to its processing for the purposes described in this Privacy Policy."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Consent may be withdrawn at any time by contacting: ",
	                      _react2.default.createElement(
	                        "a",
	                        { href: "mailto:info@winpeforum.com" },
	                        "info@winpeforum.com"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Withdrawal of consent will not affect the lawfulness of processing carried out before such withdrawal."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "5. Website Usage and Analytics"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "At present, Winpe\u2019s website does not intentionally use cookies for tracking or advertising purposes."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Limited technical or analytics-related information may still be collected through standard website hosting, security tools, or third-party integrations to ensure proper website functionality and performance."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "If Winpe introduces cookies or similar tracking technologies in the future, this Privacy Policy will be updated accordingly."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "6. Sharing of Personal Data"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "We may share personal data with trusted third parties where necessary, including:"
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Event hosting and communication platforms"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Technology and website support vendors"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Research, survey, or analytics service providers"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Partner organisations or collaborators for jointly hosted initiatives"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "We do not sell, rent, or trade personal data to third parties."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Some of these service providers may process or store personal data on servers located outside India, subject to applicable legal and contractual safeguards."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "7. Data Retention"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "We retain personal data only for as long as necessary to fulfil the purposes for which it was collected, including operational, legal, administrative, archival, research, and knowledge dissemination purposes."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "The duration of retention may vary depending on the nature of engagement, legal obligations, organisational requirements, and archival purposes."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Event recordings, knowledge sessions, interviews, photographs, videos, and educational content published on Winpe\u2019s official platforms may continue to be retained as part of ongoing institutional and archival activities."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Where personal data is no longer required for the purposes for which it was collected, and where retention is not otherwise required by law or legitimate organisational needs, Winpe will securely delete, anonymise, or archive such information in accordance with applicable law."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "8. Your Rights"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Subject to applicable law, you may:"
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Request access to your personal data"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Request correction, completion, updating, or erasure of personal data"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Withdraw consent where processing is based on consent"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Raise grievances regarding processing of your personal data"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "Nominate another individual to exercise your rights in accordance with applicable law"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Requests may be submitted to: ",
	                      _react2.default.createElement(
	                        "a",
	                        { style: { color: 'blue', textDecoration: 'underline' }, href: "mailto:info@winpeforum.com" },
	                        "info@winpeforum.com"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "9. Data Security"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "We implement reasonable technical, administrative, and organisational safeguards to protect personal data against unauthorised access, disclosure, misuse, alteration, or loss."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "These safeguards may include restricted access controls, secure storage systems, vendor assessments, and internal confidentiality practices."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "10. Children's Privacy"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Winpe's services are intended for individuals aged 18 years and above. We do not knowingly collect personal data from children."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "11. Third-Party Links"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Our website may contain links to external websites or third-party platforms. Winpe is not responsible for the privacy practices or content of such external websites."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "12. Grievance Officer"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "For questions, concerns, or complaints regarding this Privacy Policy or personal data processing, please contact:"
	                    ),
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Tina Ahluwalia"
	                    ),
	                    " ",
	                    _react2.default.createElement("br", null),
	                    "Email: ",
	                    _react2.default.createElement(
	                      "a",
	                      { style: { color: 'blue', textDecoration: 'underline' }, href: "mailto:info@winpeforum.com" },
	                      "info@winpeforum.com"
	                    ),
	                    " ",
	                    _react2.default.createElement("br", null),
	                    "Response Timeline: Within 7 working days ",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Data Principals may contact the Grievance Officer regarding the exercise of their rights under applicable data protection laws."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "13. Changes to This Privacy Policy"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "We may update this Privacy Policy periodically to reflect operational, legal, or regulatory changes."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "The updated version will be posted on this page along with the revised \"Last Updated\" date."
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "14. Contact Us"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "For any questions regarding this Privacy Policy or Winpe\u2019s data practices, please contact:"
	                    ),
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Winpe"
	                    ),
	                    _react2.default.createElement("br", null),
	                    "Email: ",
	                    _react2.default.createElement(
	                      "a",
	                      { style: { color: 'blue', textDecoration: 'underline' }, href: "mailto:info@winpeforum.com" },
	                      "info@winpeforum.com"
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "   ",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null)
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return WiI;
	}(_react.Component);
	
	WiI.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = WiI;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-index-js-175fc15f88a62e9ee8c8.js